import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as socketIo from 'socket.io-client';

const SERVER_URL = environment.socketRoot;

@Injectable()
export class SocketService {

	private socket;
	private id;

	public initSocket(id): void {
		console.log('INIT SOCKET', id);
		this.id = id.toLowerCase();
		this.socket = socketIo.connect(SERVER_URL, { transports: ['websocket'], upgrade: false, secure: true });
	}

	public closeSocket(id): void {
		if (this.socket) {
			console.log('CLOSE SOCKET', id);
			this.socket.disconnect();
		} else {
			console.log('Attempted to CLOSE SOCKET, but socket not initialized', id);
		}
	}


	// public send(message): void {
	// 	this.socket.emit('message', message);
	// }

	public onMessage(): Observable<any> {
		const self = this;
		return new Observable<any>(observer => {
			this.socket.on(self.id, (res) => observer.next(res));
		});
	}

	public onEvent(event: Event): Observable<any> {
		const self = this;
		return new Observable<Event>(observer => {
			this.socket.on(event, () => observer.next());
		});
	}

	public onUser(user: String): Observable<any> {
		return new Observable<Event>(observer => {
			this.socket.on(user, () => observer.next());
		});
	}

}

export enum Event {
	CONNECT = 'connect',
	DISCONNECT = 'disconnect'
}
